import { default as domainCatalogGrid } from './grid/services'
import { default as domainCatalogJoin } from './juncao/services'
import { default as domainCatalogGridGen } from './gerar-ofertas/services'

export default {
    domainCatalogGrid,
    domainCatalogJoin,
    domainCatalogGridGen
}
